import { render, staticRenderFns } from "./Recuperate.vue?vue&type=template&id=7158379c&scoped=true"
import script from "./Recuperate.vue?vue&type=script&lang=js"
export * from "./Recuperate.vue?vue&type=script&lang=js"
import style0 from "./Recuperate.vue?vue&type=style&index=0&id=7158379c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7158379c",
  null
  
)

export default component.exports